export enum UserRoles {
    BUILDER_SUPER_ADMIN = 'builder_super_admin', // created account first time
    BUILDER_ADMIN = 'builder_admin',
    BUILDER_EMPLOYEE = 'builder_employee'
    // ADMIN = 'admin',
    // STUDENT = 'student',
    // ACCOUNT_ADMIN = 'account_admin',
  }
  